import * as actions from "../actions";

const initialState = {
  
  step: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.STORE_RESIDENCY_DETAILS:
      return {
        ...state,
        ...action.payload
      }
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
   
    default:
      return state
  }
}
